import { useMutation } from '@tanstack/react-query';

import { type components, updateYourOwnUser } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';

export default function useUpdateUser() {
  return useMutation({
    mutationFn: (body: components['schemas']['UserMeUpdateCmd']) =>
      updateYourOwnUser(
        {
          body,
        },
        wgApi,
      ),
  });
}
